// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.rpc.client

import org.multipaz.cbor.DataItem
import org.multipaz.rpc.client.RpcAuthorizedDeviceClient.HostData
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Tstr

internal fun HostData.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "EPaDujdGzsZUPqUcLWgy6bBRXwv9IEGB6Rn_-CTv9X4")
internal val HostData_cborSchemaId = ByteString(16, -10, -125, -70, 55, 70, -50, -58, 84, 62, -91, 28, 45, 104, 50, -23, -80, 81, 95, 11, -3, 32, 65, -127, -23, 25, -1, -8, 36, -17, -11, 126)

internal fun HostData.Companion.fromCbor(data: ByteArray): HostData {
    return HostData.fromDataItem(Cbor.decode(data))
}

internal val HostData.Companion.cborSchemaId: ByteString
    get() = HostData_cborSchemaId

internal fun HostData.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("clientId", Tstr(this.clientId))
    builder.put("deviceAttestationId", Tstr(this.deviceAttestationId))
    return builder.end().build()
}

internal fun HostData.Companion.fromDataItem(dataItem: DataItem): HostData {
    val clientId = dataItem["clientId"].asTstr
    val deviceAttestationId = dataItem["deviceAttestationId"].asTstr
    return HostData(
        clientId = clientId,
        deviceAttestationId = deviceAttestationId,
    )
}
